/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section2_P1Inputs */

const en_privacy_section2_p1 = /** @type {(inputs: Privacy_Section2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON does not collect, store, or transmit any of the following:`)
};

const ko_privacy_section2_p1 = /** @type {(inputs: Privacy_Section2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 다음 데이터를 수집, 저장 또는 전송하지 않습니다:`)
};

const ja_privacy_section2_p1 = /** @type {(inputs: Privacy_Section2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONは以下のデータを収集、保存、送信しません：`)
};

/**
* | output |
* | --- |
* | "PureJSON does not collect, store, or transmit any of the following:" |
*
* @param {Privacy_Section2_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section2_p1 = /** @type {((inputs?: Privacy_Section2_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section2_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section2_p1(inputs)
	if (locale === "ko") return ko_privacy_section2_p1(inputs)
	return ja_privacy_section2_p1(inputs)
});